<template>
  <div class="main">

      <div class="tutorial-content-wrapper">
        <h3>All done! So what have we covered? <TextToSpeechSimple :inputText="textOneSpeech"></TextToSpeechSimple></h3><!-- 
        <p>{{interactionNeeded ? 'This is an interactive page' : 'This is a static page'}}</p> -->
        <!-- <button class="button is-primary" @click="sendData">Interact</button> -->
        <ul>
          <li v-for="item in helperItems" :key="item.id">{{item.title}}</li>
        </ul>

      </div>

      <!-- <img class="hero-pic" src="../assets/boat-pic-1.jpg" alt="Fishing Boat"> -->
      <img class="smiley" src="../assets/popeye.jpg" alt="Offshore SMS">

      <div class="bottom-spacer"></div>


  </div>
</template>


<script>

import { db } from '../main.js';
import TextToSpeechSimple from '../components/TextToSpeechSimple.vue';

export default {

  components: {
      TextToSpeechSimple,
  },

  props: [
      'interactionNeeded',
  ],

  mounted() {
    this.loadHelperItems();
  },

  computed: {

  },

  data() {
    return {
      hasInteracted: false,
      helperItems: [],
      textOneSpeech: 'All done! So, what have we covered?',
    }
  },

  methods: {

    loadHelperItems: function() {
      var self = this;
      db.collection("smsRevisionItems").orderBy("key","asc").onSnapshot(function(querySnapshot) {
        self.helperItems = [];
        querySnapshot.forEach(function(doc) {
          self.helperItems.push({
            id: doc.id,
            title: doc.data().title,
            // details: doc.data().details
          });
        });
      });
    },

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    sendData: function() {
      let self = this;
      self.hasInteracted = true;
      let result = {
        hasInteracted: self.hasInteracted,
      }
      this.$emit('sendData', result)
    },
    
  }
}
</script>



<style lang="scss" scoped>

  button {
    margin-top: 1rem;
  }
  ul {
    margin: 2rem auto 1rem;
    max-width: 500px;
    li {
      line-height: 1.5rem;
      margin-bottom: 1.7rem;
      font-size: 1.2rem;
      text-indent: -29px;
      margin-left: 30px;
      &:before {
        content: url('../assets/tick.jpg');
        margin-right: 10px;
      }
    }
  }
  img {
    max-width: 200px;
  }

</style>